import VectorSource from 'ol/source/Vector';
import Point from 'ol/geom/Point';
import _ from 'lodash';
import PointFeature from './PointFeature';

export default class PointFeatureSource<T extends PointFeature> extends VectorSource<Point> {
    maxOrder = 0

    addFeature(point: T) {
        super.addFeature(point)
        if(point.order > this.maxOrder) {
            this.maxOrder = point.order
        }
    }
    addFeatures(points: T[]) {
        super.addFeatures(points)
        const maxOrderOfNew = _.max(points.map(p => p.order)) || 0
        if(maxOrderOfNew > this.maxOrder) {
            this.maxOrder = maxOrderOfNew
        }
    }
    
    getFeatures() {
        return super.getFeatures().map(a => (a as T)).sort((a, b) => a.order - b.order)
    }
}